

import React, { useState, useEffect } from 'react';
import {
    Box, Typography, List, Tab, Tabs, ListItem, ListItemText, TextField,
    Button, Paper
} from '@mui/material';
import DashboardLayout from './DashboardLayout';
import axios from 'axios';
import PlaneamentoPaletesForm from './PlaneamentoPaletesForm';
/* global BrowserPrint */

const apiBaseURL = 'https://plasticemployers.duckdns.org';      // IP da rede local
    axios.defaults.baseURL = apiBaseURL;
    axios.defaults.withCredentials = true;
    
    // Função para obter o token CSRF do cookie
    function getCsrfToken() {
        const name = 'csrftoken=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookies = decodedCookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();
            if (cookie.startsWith(name)) {
                return cookie.substring(name.length);
            }
        }
        return '';
    }
    
    // Configurar o header de autorização com o token JWT e CSRF token
    axios.interceptors.request.use((config) => {
        const token = localStorage.getItem('access');
        
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        } else {
            console.error('Token JWT não encontrado.');
        }
    
        // Adicionar o token CSRF em todas as requisições
        config.headers['X-CSRFToken'] = getCsrfToken();
    
        return config;
    });
    
    const Armazem = () => {
        const [searchTerm, setSearchTerm] = useState('');
        const [encomendas, setEncomendas] = useState([]);
        const [selectedEncomenda, setSelectedEncomenda] = useState(null); // Estado para encomenda selecionada
        const [barcode, setBarcode] = useState('');
        const [selectedTab, setSelectedTab] = useState(0);
        const empregadoMap = {
            1: "Admin",
            2: "Sónia Regina da Silva Maio Figueiredo",
            3: "Hélder Manuel Abrantes Ferreira",
            4: "José Carlos Monteiro Menino",
            5: "Francisco Santos Gouveia",
            6: "Alexandre Miguel Pereira Celestino",
            7: "Débora Filipa Soares Pereira",
            8: "Diana Sofia Oliveira Costa",
            9: "Elioenai Ferreira Borges",
            10: "Emília Rosa Correia Ferreira e Rodrigues",
            11: "Fernanda Hellen Vieira Tito",
            12: "Fernando Agostinho dos Santos Nogueira",
            13: "Fernando Viegas André",
            14: "Gabriel Saraiva Moreira",
            15: "Gonçalo Filipe Figueiredo Silveira",
            16: "Igor Augusto Henriques Figueiredo",
            17: "Ísaias Sutério da Silva",
            18: "João Miguel Cerveira Fernandes",
            19: "João Paulo Palma Silvestre",
            20: "Joceline da Paixão Quiala João",
            21: "José Miguel Abrantes Barreira",
            23: "Karla Nayara Vasconcelos Vicente",
            24: "Manuel Fernando da Silva Lelo",
            25: "Mariana Henriques Carvalho Marques",
            26: "Micaela Teresa Dinis Neves Clara",
            27: "Nadiia Khomenchuk",
            28: "Octávio José de Loureiro Marques",
            29: "Paulo Alexandre de Oliveira Albuquerque",
            30: "Renato Daniel Almeida Marques",
            31: "Rogério Filipe Fernandes Correia",
            32: "Sonia Miguel Francisco Passagem",
            33: "Taynara Freitas de Queiroz",
            34: "Yuri Domingos da Silva",
            35: "Açucena Maria Amaral Marques",
            36: "Marco Daniel Loureiro Tavares",
            37: "Bernd Veldman",
            38: "João Carlos Soares Pereira"
        };
    
        const handleTabChange = (event, newValue) => {
            setSelectedTab(newValue);
        };
    
        // Carregar o token CSRF e buscar encomendas antes de buscar dados da API
        useEffect(() => {
            axios.get('/api/set-csrf/')
                .then(() => {
                    fetchEncomendas();
                })
                .catch(error => console.error('Erro ao definir o token CSRF:', error));
        }, []);
    
        // Função para buscar encomendas da API
        const fetchEncomendas = async () => {
            try {
                const response = await axios.get('/api/encomendas/');
                setEncomendas(response.data.message ? [] : response.data);
            } catch (error) {
                console.error('Erro ao buscar encomendas:', error);
                setEncomendas([]);
            }
        };
    
        const handleSearchChange = (e) => setSearchTerm(e.target.value);
    
        const handleBarcodeChange = (e) => {
            const code = e.target.value;
            setBarcode(code);
    
            if (code.length > 0) {
                // Simulando a saída da encomenda ao colar um código de barras
                axios.post('/api/encomendas/sair/', { codigo_barras: code })
                    .then((response) => {
                        console.log('Encomenda saiu:', response.data);
                        setBarcode(''); // Limpa o campo de código de barras
                        fetchEncomendas(); // Atualiza a lista de encomendas
                    })
                    .catch((error) => console.error('Erro ao sair da encomenda:', error));
            }
        };
    
    
        const handleSairEncomenda = (codigoBarras) => {
            axios.post('/api/encomendas/sair/', { codigo_barras: codigoBarras })
                .then((response) => {
                    console.log('Encomenda saiu:', response.data);
                    fetchEncomendas(); // Atualiza a lista de encomendas após a saída
                    setSelectedEncomenda(null); // Limpa a encomenda selecionada
                })
                .catch((error) => console.error('Erro ao sair da encomenda:', error));
        };
    
        // Função para definir a encomenda selecionada
        const handleEncomendaClick = (encomenda) => {
            setSelectedEncomenda(encomenda);
        };
    
        // Função para imprimir o ZPL diretamente na impressora
        function enviarZPLParaImpressora(zplCode) {
            BrowserPrint.getDefaultDevice("printer", function(printer) {
                if (printer) {
                    printer.send(zplCode, function() {
                        console.log("Etiqueta enviada para a impressora com sucesso.");
                    }, function(error) {
                        console.error("Erro ao enviar para a impressora:", error);
                    });
                } else {
                    console.error("Impressora não encontrada.");
                }
            });
        }
    
        const filteredEncomendas = encomendas.filter((encomenda) =>
            encomenda.cliente && encomenda.cliente.toLowerCase().includes(searchTerm.toLowerCase())
        );
    
        return (
            <DashboardLayout>
                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
                    {/* Tabs para alternar entre as páginas */}
                    <Tabs value={selectedTab} onChange={handleTabChange} sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tab label="Saída de Encomendas" />
                        <Tab label="Planeamento de Paletes" />
                    </Tabs>
    
                    {/* Conteúdo das abas */}
                    <Box sx={{ flexGrow: 1, p: 2 }}>
                        {selectedTab === 0 && (
                            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                {/* Conteúdo da aba "Saída de Encomendas" */}
                                <TextField
                                    label="Escaneie o Código de Barras"
                                    value={barcode}
                                    onChange={handleBarcodeChange}
                                    fullWidth
                                    sx={{ mb: 2 }}
                                />
    
                                <Box sx={{ display: 'flex', flexGrow: 1 }}>
                                    {/* Menu lateral com lista de encomendas */}
                                    <Box sx={{ width: 300, flexShrink: 0, mr: 3 }}>
                                        <TextField
                                            label="Procurar encomenda"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                            fullWidth
                                            sx={{ mb: 2 }}
                                        />
                                        <List>
                                            {filteredEncomendas.length > 0 ? (
                                                filteredEncomendas.map((encomenda, index) => (
                                                    <ListItem
                                                        button
                                                        key={index}
                                                        onClick={() => handleEncomendaClick(encomenda)}
                                                    >
                                                        <ListItemText 
                                                            primary={encomenda.referencia} 
                                                            secondary={`Cliente: ${encomenda.cliente}`} 
                                                        />
                                                    </ListItem>
                                                ))
                                            ) : (
                                                <Typography>Nenhuma encomenda</Typography>
                                            )}
                                        </List>
                                    </Box>
    
                                    {/* Detalhes da encomenda selecionada */}
    <Box sx={{ flexGrow: 1 }}>
        <Paper
            sx={{
                p: 3,
                mt: 3,
                position: 'fixed', // Altera position para fixed
                top: 150, // Define a distância do topo da tela
                right: 16, // Define a distância do lado direito da tela
                width: '400px', // Ajusta a largura conforme necessário
                maxHeight: '90vh', // Limita a altura para evitar overflow
                overflowY: 'auto', // Permite rolagem interna caso o conteúdo exceda a altura máxima
                boxShadow: 3, // Adiciona sombra para destaque
                zIndex: 1200, // Garante que fique acima de outros elementos
            }}
        >
            <Typography variant="h6">Detalhes da Encomenda Selecionada</Typography>
            {selectedEncomenda ? (
                <>
                    <Typography><strong>Cliente:</strong> {selectedEncomenda.cliente}</Typography>
                    <Typography><strong>Referência:</strong> {selectedEncomenda.referencia}</Typography>
                    <Typography><strong>Data de Entrada:</strong> {new Date(selectedEncomenda.data_entrada).toLocaleDateString()}</Typography>
                    <Typography><strong>Quantidade Total de Paletes:</strong> {selectedEncomenda.numero_paletes_total}</Typography>
                    
                    <Box mt={2}>
                        {selectedEncomenda.detalhes.map((palete, index) => (
                            <Box key={index} sx={{ mb: 2, p: 2, border: '1px solid #ccc', borderRadius: '4px' }}>
                                <Typography><strong>Palete {index + 1}</strong></Typography>
                                <Typography><strong>Tamanho:</strong> {palete.tamanho || 'N/A'}</Typography>
                                <Typography><strong>Quantidade:</strong> {palete.quantidade || 'N/A'}</Typography>
                                <Typography><strong>Código de Barras:</strong> {palete.codigo_barras || 'N/A'}</Typography>
                                <Typography><strong>Prateleira:</strong> {palete.prateleira || 'N/A'}</Typography>
                                <Typography><strong>Adicionado por:</strong> {empregadoMap[palete.empregado] || 'N/A'}</Typography>

                                <Typography sx={{ mt: 2 }}>
                                    <strong>Descrição:</strong> {selectedEncomenda.descricao || 'Sem descrição'}
                                </Typography>

                            </Box>
                        ))}
                    </Box>
    
                    <Box sx={{  bottom: 16, right: 16, display: 'flex', gap: 2 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => enviarZPLParaImpressora(selectedEncomenda.zplCode)}
                        >
                            Imprimir Etiqueta
                        </Button>
    
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => handleSairEncomenda(selectedEncomenda.detalhes[0].codigo_barras)}
                        >
                            Expedir Encomenda
                        </Button>
                    </Box>
                </>
            ) : (
                <Typography>Selecione uma encomenda na lista à esquerda para visualizar os detalhes.</Typography>
            )}
        </Paper>
    </Box>
    
                                </Box>
                            </Box>
                        )}
    
                        {selectedTab === 1 && (
                            <Box>
                            {/* Componente Planeamento de Paletes */}
                            <PlaneamentoPaletesForm />
                        </Box>
                        )}
                    </Box>
                </Box>
            </DashboardLayout>
        );
    };
    
    export default Armazem;
    